// src/components/Home/TeamMetricsWidget.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";

const TeamMetricsWidget = ({ teamMetrics }) => {
  const navigate = useNavigate();

  if (!teamMetrics) {
    return (
      <div className="dashboard-widget">
        < FullScreenLoader message="Carregando Kpi's Time..." />
      </div>
    );
  }

  const metrics = [
    {
      label: "Leads Hoje",
      value: teamMetrics.leads_today || 0,
      color: "#3498db",
      icon: "👥",
    },
    {
      label: "Mensagens Enviadas",
      value: teamMetrics.messages_sent_today || 0,
      color: "#2ecc71",
      icon: "💬",
    },
    {
      label: "Automações Disparadas",
      value: teamMetrics.automations_triggered_today || 0,
      color: "#f39c12",
      icon: "⚡",
    },
  ];

  return (
    <div className="dashboard-widget">
      <h3 style={{ marginBottom: "15px" }}>Atividades do Time Hoje</h3>

      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "12px", marginBottom: "15px" }}>
        {metrics.map((metric, index) => (
          <div
            key={index}
            style={{
              padding: "15px",
              background: "var(--bg-tertiary",
              borderRadius: "8px",
              borderLeft: `4px solid ${metric.color}`,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: "12px", color: "#7f8c8d", marginBottom: "5px" }}>
                  {metric.label}
                </div>
                <div style={{ fontSize: "24px", fontWeight: "bold", color: metric.color }}>
                  {metric.value}
                </div>
              </div>
              <div style={{ fontSize: "32px", opacity: 0.3 }}>{metric.icon}</div>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={() => navigate("/operation-team")}
        style={{
          width: "100%",
          padding: "8px",
          background: "transparent",
          border: "1px solid #e67e22",
          borderRadius: "4px",
          color: "#e67e22",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        Ver Métricas do Time →
      </button>
    </div>
  );
};

export default TeamMetricsWidget;
